import React from 'react';

import { CoreApplicationContext } from '@eb/context-gen';
import ModuleList, { ModuleInterface } from './components/ModuleList';
import { deepKeysToCamel } from '@eb/transformation-utils';

import './app.scss';

export interface AppProps {
    modules: {
        body_content: [ModuleInterface];
    };
    env: any;
    user: any;
}

export const App: React.FunctionComponent<
    AppProps & CoreApplicationContext
> = ({ modules, env, user }) => (
    <section className="content-container">
        <ModuleList
            env={env}
            user={user}
            modules={deepKeysToCamel(modules['body_content'])}
        />
    </section>
);
